import React from 'react';
import Form from '../Form';
import Card from '../../atoms/Card';

export interface ImportantProductsSummaryCardProps {
  /**
   * スマホ 乗換(転入) 件数
   */
  smartphoneMnpCount: number;
  /**
   * スマホ 純新規 件数
   */
  smartphoneNewCount: number;
  /**
   * スマホ 番号移行 件数
   */
  smartphoneTransferCount: number;
  /**
   * スマホ 機種変更 件数
   */
  smartphoneChangeCount: number;
  auroraContractCount: number;
  sbHikariContractCount: number;
  sbAirContractCount: number;
}

const labelClassName = 'u-text-left u-text-secondary u-text-s ';
const countClassName = 'u-text-left u-text-m u-text-bold u-w3s';

const countSummarySuffix = '合計';
const countPrefix = '件';

const ImportantProductsSummaryCard: React.FC<ImportantProductsSummaryCardProps> = ({
  smartphoneNewCount,
  smartphoneChangeCount,
  smartphoneMnpCount,
  smartphoneTransferCount,
  auroraContractCount,
  sbHikariContractCount,
  sbAirContractCount,
}: ImportantProductsSummaryCardProps) => {
  return (
    <Form.Fileld className='u-mb8' label='商談中の重要商品'>
      <Card isNoShadow isBordered className='u-mt8'>
        <Card.Content className='u-p8'>
          <div className='u-flex u-space-between'>
            <div className='important-products-summary-card__left-grid'>
              <div className={labelClassName}>{`スマホ乗換（転入）`}</div>
              <div className={countClassName}>{`${smartphoneMnpCount}${countPrefix}`}</div>

              <div className={labelClassName}>{`スマホ純新規`}</div>
              <div className={countClassName}>{`${smartphoneNewCount}${countPrefix}`}</div>

              <div className={labelClassName}>{`スマホ番号移行`}</div>
              <div className={countClassName}>{`${smartphoneTransferCount}${countPrefix}`}</div>

              <div className={labelClassName}>{`スマホ機種変更`}</div>
              <div className={countClassName}>{`${smartphoneChangeCount}${countPrefix}`}</div>
            </div>
            {/* 区切り用縦線 */}
            <div className='important-products-summary-card__vertical-divider'></div>

            <div className='important-products-summary-card__right-grid'>
              <div className={labelClassName}>{`SB光`}</div>
              <div className={labelClassName}>{countSummarySuffix}</div>
              <div className={countClassName}>{`${sbHikariContractCount}${countPrefix}`}</div>

              <div className={labelClassName}>{`SBAir`}</div>
              <div className={labelClassName}>{countSummarySuffix}</div>
              <div className={countClassName}>{`${sbAirContractCount}${countPrefix}`}</div>

              <div className={labelClassName}>{`SB光＋`}</div>
              <div className={labelClassName}>{countSummarySuffix}</div>
              <div className={countClassName}>{`${auroraContractCount}${countPrefix}`}</div>
            </div>
          </div>
        </Card.Content>
      </Card>
    </Form.Fileld>
  );
};

export default ImportantProductsSummaryCard;
